import React, { useEffect } from 'react';
import { Navigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { solutionPage } from '../lib/marketplaceSolutions';

/**
 * /marketplace/:slug — the one door every link into a solution goes through.
 *
 * Orbit recommendations, proposal cards, catalog landing_urls and old bookmarks
 * all link to /marketplace/<slug>. Only the chatbot has a page at that address;
 * every other slug used to match no route and render an empty screen. This
 * sends a known slug to the page that serves it (WhatsApp is a channel of the
 * AI Assistant, the SDK keys are its Developer tab) and anything else back to
 * the Marketplace with a note, never to a blank page.
 */
const MarketplaceSolutionRedirect: React.FC = () => {
  const { slug } = useParams<{ slug: string }>();
  const target = solutionPage(slug);

  useEffect(() => {
    if (!target) toast.info("That solution isn't available yet. Here's what you can set up today.");
  }, [target]);

  return <Navigate to={target || '/marketplace'} replace />;
};

export default MarketplaceSolutionRedirect;
